var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPerson(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99805 2.75C10.8449 2.75158 11.6723 3.11969 12.2939 3.7998C12.879 4.43998 13.233 5.30595 13.2764 6.22949L13.2812 6.41504C13.2809 7.33476 12.9038 8.13468 12.3291 8.8125C11.9802 9.22406 12.0945 9.86279 12.584 10.1191C14.8698 11.3154 16.8709 13.9225 17.2021 17.0801C17.2062 17.1191 17.1954 17.1532 17.1641 17.1855C17.1294 17.2214 17.0718 17.25 17 17.25H3C2.92823 17.25 2.87058 17.2213 2.83594 17.1855C2.80464 17.1532 2.79383 17.1191 2.79785 17.0801C3.12941 13.9216 5.13262 11.3156 7.41406 10.1191C7.90286 9.86281 8.0169 9.225 7.66895 8.81348C7.09521 8.13504 6.71621 7.33401 6.71582 6.41504C6.71764 5.42272 7.07936 4.48359 7.70312 3.80078C8.32448 3.12065 9.15135 2.75212 9.99805 2.75Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPerson);
export default __webpack_public_path__ + "static/media/icon-person.69dfcf00.svg";
export { ForwardRef as ReactComponent };